/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Product = {
    readonly id?: string;
    type: Product.type;
    feed_id?: string;
    material_id?: string;
    duration: Product.duration;
    is_enable?: boolean;
    name: string;
    description?: string;
    price: number;
    link?: string;
    readonly created_at?: string;
    readonly updated_at?: string;
    thanks?: {
        title: string;
        text: string;
    };
    banner?: {
        name: string;
        description: string;
        url: string;
        url_mobile: string;
        label: string;
        btn: string;
    };
};
export namespace Product {
    export enum type {
        ALL = 'all',
        COURSE = 'course',
        FEED = 'feed',
        MATERIAL = 'material',
        DIGEST = 'digest',
        MASHTAB = 'mashtab',
    }
    export enum duration {
        MONTH = 'month',
        FULL = 'full',
    }
}

